export const DURATIONS = [ '1h', '1d', '3d', '7d', '15d', '30d', '60d', '90d', '6m', 'permanent' ];
export const BAN_LEVELS = {
    POSTING: 'posting',
    GHOST: 'ghost',
    LOGIN: 'login',
    HIDE: 'hide',
    NONE: 'none',
};
export const BAN_TYPES = [ BAN_LEVELS.LOGIN, BAN_LEVELS.POSTING, BAN_LEVELS.HIDE, BAN_LEVELS.GHOST ];

// copied from PHP
export const DURATION_MAP = {
    '1h': 3600,
    '1d': 86400,
    '3d': 259200,
    '7d': 604800,
    '15d': 1296000,
    '30d': 2592000,
    '60d': 5184000,
    '90d': 7776000,
    '6m': 15811200,
    '12m': 31536000,
};
export const NO_BAN = {
    ban_level: BAN_LEVELS.NONE,
};
